import { Component, OnInit } from '@angular/core';
import { HomeService } from '../_services';
import { map } from 'rxjs/operators';

import { first } from 'rxjs/operators';
import { Lightbox } from 'ngx-lightbox';
import { environment } from 'src/environments/environment';

declare let $: any;

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {
  tipo: any;
  imagenesFlyer: any;
  imagenesFlyer2: Array<any> = [];
  monedas: any;
  infoAgropecuaria: any;
  constructor(private homeService: HomeService, private lightbox: Lightbox) { }

  ngOnInit() {
    this.getImagenesFlyer();
    this.getCotizaciones();
    this.getInfoAgropecuaria();

    (function (d, s, id) {
      let js;
      const fjs = d.getElementsByTagName(s)[0];
      if (!d.getElementById(id)) {
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://weatherwidget.io/js/widget.min.js';
        fjs.parentNode.insertBefore(js, fjs);
      }
    })(document, 'script', 'weatherwidget-io-js');
  }

  onSeCargoClima() {
    console.log('se cargó clima');
  }

  ngAfterViewInit() { }

  getCotizaciones() {
    console.log('nuevo');
    const nombres = { USD: 'DÓLAR', ARS: 'PESO', BRL: 'REAL' };
    this.homeService.getCotizaciones().subscribe((data: any) => {
      if (data.items.length > 0) {
        this.monedas = data.items
          .filter(i => {
            return ['USD', 'ARS', 'BRL'].includes(i.isoCode);
          })
          .map(i => {
            i.nombre = nombres[i.isoCode];
            return i;
          });
        console.log('nuevo');
      }
    });
  }

  getImagenesFlyer() {
    this.homeService.getImagenesPorTipo('flyer').subscribe(
      data => {
        this.imagenesFlyer = data;
        this.imagenesFlyer.forEach(element => {
          const album = {
            src: environment.baseUrl + '/..' + element.url,
            caption: '',
            thumb: environment.baseUrl + '/..' + element.url
          };
          this.imagenesFlyer2.push(album);
        });
      },
      error => {
        console.log(error);
      }
    );
  }

  openImage(index: number): void {
    this.lightbox.open(this.imagenesFlyer2, index);
  }

  closeImage(): void {
    // close lightbox programmatically
    this.lightbox.close();
  }

  getInfoAgropecuaria() {
    this.homeService.getInfoAgropecuaria().subscribe(data => {
      this.infoAgropecuaria = data;
    });
  }
}
